<div class="page-title">
  <h1>{{ data.titleTr }}</h1>
</div>


<div class="course-container" [dir]="language === 'ar' ? 'rtl' : 'ltr'">


  <div class="row g-4 main-row">

    <!-- Left column: image + price card -->
    <div class="col-12 col-md-7  left-col">
      <div class="media-wrap">
        <video width="100%" controls muted *ngIf="data.video">
          <source [src]="data.video" type="video/mp4" />
          <source [src]="data.video" type="video/ogg" />
          <source [src]="data.video" type="video/x-ms-wmv" />
        </video>
        <img class="course-img" *ngIf="!data.video && data.imageUrl" [src]="data.imageUrl" [alt]="data.titleTr" />
      </div>

    </div>

    <!-- Right column: what you'll learn -->
    <div class="col-12 col-md-5">
      <div class="learn-card">
        <h2 class="section-title">ماذا ستتعلم</h2>
        <div class="row mt-3">
           <ng-container *ngFor="let item of data.courseInfo.whatYouWillLearn; let i = index">
      <div class="col-12 learn-item mb-2" *ngIf="i < 4 || showAll">
        <i class="bi bi-check2"></i>
        <span>{{ item.content }}</span>
      </div>
    </ng-container>
        </div>
         <button
    class="see-all-btn"
    *ngIf="data.courseInfo.whatYouWillLearn.length > 4"
    (click)="showAll = !showAll">
    {{ showAll ? 'إخفاء' : 'عرض الكل' }}
    <i class="bi" [ngClass]="showAll ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
  </button>
        <!-- Price card -->
        <div class="price-card" *ngIf="!isProductPurchased">
          <div class="price-row">
            <span class="price-label">السعر:</span>
            <span class="price-value" [class.sale-price]="data.courseInfo.sales">
              {{ data.courseInfo.pricing }}
            </span>
          </div>
          <div class="price-row" *ngIf="data.courseInfo.sales">
            <span class="price-label sale"> السعر بعد الخصم :</span>
            <span class="price-sale">{{ data.courseInfo.sales }} </span>
          </div>
          <button class="subscribe-btn" (click)="onSubscribeClick()">اشترك الان</button>
          <div class="payment-methods">
            <img src="assets/Al-Bershama/icons/image 21 (1).png" alt="e&" class="payment-icon" />
            <img src="assets/Al-Bershama/icons/SVGBrand.com_orange_sa.png" alt="orange" class="payment-icon" />
            <img src="assets/Al-Bershama/icons/image 26.png" alt="vodafone" class="payment-icon" />
            <img src="assets/Al-Bershama/icons/image 27.png" alt="we" class="payment-icon" />
            <img src="assets/Al-Bershama/icons/8408-visa_102499.png" alt="Visa" class="payment-icon" />
          </div>
        </div>

        <div class="price-card" *ngIf="isProductPurchased">
          <button class="subscribe-btn" routerLink="/ar/course/{{ data.title }}">ابدأ الكورس</button>
        </div>
      </div>
    </div>

  </div>

  <!-- Course content accordion -->
  <div class="course-content-section">
    <h2 class="section-title">محتوى الدورة</h2>
    <div class="accordion">
      <div *ngFor="let item of data.courseInfo.courseInclude" class="accordion-item">
        <input type="checkbox" id="{{ item.title }}" />
        <label for="{{ item.title }}" class="accordion-header">
          {{ item.title }}
        </label>
        <div class="accordion-content">
          <div class="row my-2" *ngFor="let detail of item.details">
            <i class="bi bi-check2 col-auto"></i>
            <span class="col">{{ detail.content }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button class="start-btn" *ngIf="!isProductPurchased" (click)="onSubscribeClick()">ابدأ الان </button>
</div>